module.exports = __webpack_public_path__ + "img/9788963706665.f66f06a9.jpg";